import type { Permission } from '@/types/auth.types'

export type RoutePermissionRule =
    | { kind: 'single'; permission: Permission }
    | { kind: 'any'; permissions: Permission[] }

export const routePermissionRules: Record<string, RoutePermissionRule> = {
    // Main menu routes (index/view)
    '/units': { kind: 'any', permissions: ['unit-view', 'unit-create', 'unit-update', 'unit-delete', 'unit-reset-pass', 'unit-export'] },
    '/floorplans': {
        kind: 'any',
        permissions: ['diagram-view', 'diagram-create', 'diagram-update', 'diagram-delete', 'diagram-export'],
    },
    '/versions': { kind: 'any', permissions: ['version-view', 'version-create', 'version-update', 'version-delete', 'version-export'] },
    '/history': { kind: 'any', permissions: ['session-view', 'session-export'] },
    '/feedbacks': { kind: 'any', permissions: ['survey-view', 'survey-delete', 'survey-export'] },
    '/accounts': {
        kind: 'any',
        permissions: ['account-view', 'account-create', 'account-update', 'account-delete', 'account-reset-pass', 'account-export'],
    },
    '/libraries': { kind: 'any', permissions: ['kb-view', 'doc-view', 'doc-upload', 'doc-delete', 'doc-export', 'kb-create', 'kb-update', 'kb-delete'] },
    '/robots': { kind: 'any', permissions: ['robot-view', 'robot-config', 'robot-update', 'robot-export', 'robot-event-export'] },
    '/permissions': { kind: 'any', permissions: ['permission-view', 'permission-create', 'permission-update', 'permission-delete', 'permission-export'] },
    '/events': { kind: 'any', permissions: ['event-view', 'event-create', 'event-update', 'event-delete', 'event-export'] },
    '/activity': { kind: 'any', permissions: ['robot-history'] },
    '/counters': { kind: 'any', permissions: ['reception-view', 'reception-create', 'reception-update', 'reception-delete', 'reception-export'] },
    '/mails': { kind: 'any', permissions: ['mail-server-view', 'mail-server-create', 'mail-server-update', 'mail-server-delete', 'mail-server-export'] },
    '/templates': { kind: 'any', permissions: ['mail-template-view', 'mail-template-create', 'mail-template-update', 'mail-template-delete', 'mail-template-export'] },
}

export function getRoutePermissionRule(routePathname: string): RoutePermissionRule | null {
    const entry = Object.entries(routePermissionRules).find(([base]) => routePathname === base || routePathname.startsWith(`${base}/`))
    return entry?.[1] ?? null
}

